import React from 'react';
import { Bot, User } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const MessageBubble = ({ msg }) => (
  <div className={`flex gap-2 ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
    {msg.role === 'assistant' && (
      <div className="w-7 h-7 rounded-full bg-[#2B8FD8] flex items-center justify-center shrink-0 mt-0.5">
        <Bot className="h-3.5 w-3.5 text-white" />
      </div>
    )}
    {msg.role === 'system' && (
      <div className="w-full text-center">
        <span className="text-xs text-slate-400 bg-slate-50 px-3 py-1 rounded-full">
          {msg.content}
        </span>
      </div>
    )}
    {msg.role !== 'system' && (
      <div
        className={`max-w-[min(88%,34rem)] min-w-0 overflow-hidden break-words rounded-xl px-3.5 py-2.5 text-sm ${
          msg.role === 'user'
            ? 'bg-[#2B8FD8] text-white rounded-br-sm'
            : msg.isError
              ? 'bg-red-50 text-red-700 border border-red-200'
              : 'bg-slate-100 text-slate-800 rounded-bl-sm'
        }`}
      >
        {msg.role === 'user' ? (
          <>
            {msg.mode === 'suggest' && (
              <span className="text-[10px] bg-white/20 px-1.5 py-0.5 rounded-full mb-1 inline-block">
                Change Request
              </span>
            )}
            <p className="whitespace-pre-wrap break-words">{msg.content}</p>
          </>
        ) : msg.role === 'assistant' ? (
          <div className="prose prose-sm prose-slate max-w-none break-words [&_*]:max-w-full [&_p]:my-1 [&_p]:break-words [&_ul]:my-1 [&_ol]:my-1 [&_li]:my-0.5 [&_li]:break-words [&_pre]:my-2 [&_pre]:max-w-full [&_pre]:overflow-x-auto [&_code]:text-xs [&_code]:break-all [&_h1]:text-base [&_h2]:text-sm [&_h3]:text-sm">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {msg.content}
            </ReactMarkdown>
            {msg.type === 'suggestion' && (
              <div className="mt-2 pt-2 border-t border-slate-200">
                <span className="text-[10px] font-semibold text-amber-600 uppercase tracking-wide">
                  Changes ready for review below
                </span>
              </div>
            )}
          </div>
        ) : null}
      </div>
    )}
    {msg.role === 'user' && (
      <div className="w-7 h-7 rounded-full bg-slate-600 flex items-center justify-center shrink-0 mt-0.5">
        <User className="h-3.5 w-3.5 text-white" />
      </div>
    )}
  </div>
);

export default MessageBubble;
